import React from 'react';
import clsx from 'clsx';
import { Icons } from '@shared/ui';
import STYLE from './ProductImageGallery.module.scss';
import { type SlideOptions } from './ProductImageGallery';

interface ImageGalleryNextButtonPropType {
    onClick: () => void;
    isPrevious?: boolean;
    isFeatureType: boolean;
    slideOptions: SlideOptions['slideOptions'];
}

export const ImageGalleryNextButton: React.FC<ImageGalleryNextButtonPropType> = (
    props
) => {
    const { onClick, isPrevious, isFeatureType, slideOptions } = props;

    const NextIcon = isPrevious ? Icons.csr.ArrowLeft : Icons.csr.ArrowRight;

    const className = isPrevious ? STYLE.previousButton : STYLE.nextButton;

    const slideDirectionClassNameMap = {
        horizontal: '',
        vertical: STYLE.nextButtonFeatureType,
    };

    return (
        <button
            className={clsx(
                className,
                isFeatureType && slideDirectionClassNameMap[slideOptions.thumbDirection]
            )}
            onClick={onClick}
        >
            <div className={STYLE.nextButtonBg} />
            <NextIcon className={STYLE.nextButtonIcon} weight="bold" />
        </button>
    );
};
